// Module
var code = "<div class=\"table-selector-control\"></div> ";
// Exports
export default code;